import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiUri, filterRequest } from "../../utilities/apiManager";
import axios from "axios";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
};

export const getEndContract = createAsyncThunk(
  "endContract/getEndContract",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axios.get(
        `${apiUri}/end-contracts?page=${page}&size=${size}&query=${query}${filter}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Accept-Language": document.documentElement.lang,
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
          },
        }
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateEndContract = createAsyncThunk(
  "endContract/updateEndContract",
  async ({ _id, args }, thunkApi) => {
    try {
      const { data } = await axios.put(`${apiUri}/end-contracts/${_id}`, args, {
        headers: {
          "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
          "Accept-Language": document.documentElement.lang,
        },
      });
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const getEndContractById = createAsyncThunk(
  "endContract/getEndContractById",
  async (id, thunkApi) => {
    try {
      const { data } = await axios.get(`${apiUri}/end-contracts/${id}`, {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": document.documentElement.lang,
          "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
        },
      });
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const endContractSlice = createSlice({
  name: "endContract",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getEndContract.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getEndContract.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        // Handle both possible API response structures
        state.data = payload.data?.data || payload.data || [];
        state.itemsCount = payload.data?.itemsCount || payload.itemsCount || 0;
        state.pages = payload.data?.pages || payload.pages || 0;
      })
      .addCase(getEndContract.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateEndContract.pending, (state) => {
        state.isLoading = true;
        // state.error = null;
      })
      .addCase(updateEndContract.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        // state.error = null;
        // Update the specific item in the data array
        if (payload.data) {
          const indexAt = state.data.findIndex(
            (el) => el._id === payload.data._id
          );
          if (indexAt !== -1) {
            state.data[indexAt] = payload.data;
          }
        }
      })
      .addCase(updateEndContract.rejected, (state, { payload }) => {
        state.isLoading = false;
        // state.error = payload?.message;
      })

      .addCase(getEndContractById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getEndContractById.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(getEndContractById.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      });
  },
});

export default endContractSlice.reducer;
